import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import styled from 'styled-components';
import { getSpacingValue, getSpacing } from '../../../styles/spacing.js';
import { TREE_DEFAULT_BORDER_WIDTH } from '../constants.js';

var TreeDragHandle = styled.div.withConfig({
  displayName: "TreeDragHandle",
  componentId: "sc-1vlfgg1-0"
})(function (_ref) {
  var _ref$borderWidth = _ref.borderWidth,
    borderWidth = _ref$borderWidth === void 0 ? TREE_DEFAULT_BORDER_WIDTH : _ref$borderWidth,
    disabled = _ref.disabled,
    dragging = _ref.dragging,
    isDragPlaceholder = _ref.isDragPlaceholder,
    theme = _ref.theme;
  return _objectSpread(_objectSpread({}, function () {
    if (isDragPlaceholder) {
      return {
        opacity: 0
      };
    } else if (dragging) {
      return {
        backgroundColor: theme.CTAColors.primary,
        color: theme.neutralColors.white
      };
    } else {
      return {
        backgroundColor: theme.neutralColors.silver
      };
    }
  }()), {}, {
    borderRadius: 2,
    cursor: !disabled ? "move" : "not-allowed",
    lineHeight: "".concat(getSpacingValue(8) + borderWidth * 2, "px"),
    margin: -borderWidth,
    textAlign: "center",
    zIndex: 4,
    width: getSpacing(6)
  });
});

export { TreeDragHandle };
